import './RemoteAccessModal.css';

import React, { type FC } from 'react';
import { useRemoteAccess } from '@src/contexts';
import { ModalContainer } from '@components/ModalContainer';
import { Toggle } from '@components/Toggle';

interface BodyProps {
  onClose: () => void
}

const Body: FC<BodyProps> = ({ onClose }) => {
  return (
    <div id="remote-access-modal">
      <div className="remote-access-modal-content">
        <i className="icon-cogs machine-cloud-remote-access"></i>
        <h2 style={{ fontSize: '38px' }}> Remote access enabled</h2>
        <p style={{ fontSize: '22px', lineHeight: '29px' }}>
          You cannot access the pendant while in remote access.
          <br/>
          Remote access will be automatically revoked after 2 hours of idle time
        </p>
      </div>
      <div className="remote-access-modal-controls">
        <p>Remote Access</p>
        <Toggle onClick={onClose} checked={true} onText="ON" offText="OFF" height={50} />
      </div>
    </div>
  );
};

export const RemoteAccessModal: FC = () => {
  const { remoteAccessEnabled, requestRemoteAccess } = useRemoteAccess();

  return (
    <ModalContainer show={remoteAccessEnabled} disableClose={true}>
      <Body onClose={() => { requestRemoteAccess(false); } }/>
    </ModalContainer>
  );
};
